import type { SearchResultDocument, Source, Thought } from "../api";

// Retrieval strategy picked on the admin search page; sent as the use_text_search /
// use_vector_search flags.
export const enum RetrievalMode {
    Hybrid = "hybrid",
    Vectors = "vectors",
    Text = "text"
}

export interface SpeechConfig {
    speechUrls: (string | null)[];
    setSpeechUrls: (urls: (string | null)[]) => void;
    audio: HTMLAudioElement;
    isPlaying: boolean;
    setIsPlaying: (isPlaying: boolean) => void;
}

export interface ToolCallStatus {
    callId: string;
    toolName: string;
    status: "running" | "completed";
    arguments?: string;
    resultSummary?: string;
    failed?: boolean;
}

export interface Tooltip {
    title: string;
    cloudinaryID: string;
    mediaType: string;
    publicationId: string | null;
    publicationUrl: string | null;
    interestAreas: string;
    category: string;
    score: number;
    referenceNumber: string;
    rerankerScore: number;
    lastModifiedTimestamp: Date | null;
    thumbnailUrl: string;
}

export interface Citation {
    title: string;
    footnoteNumber: number;
    path: string;
    sourceFile: string;
    tooltip: Tooltip;
    mergedChunks: boolean;
    score: number;
    rerankerScore: number;
    lastModifiedTimestamp: string | null;
    thumbnailUrl: string;
    source: SearchResultDocument;
}

// this is just for development support
export type ThoughtProcessData = Thought;

export interface SupportingContentData {
    data: { title: string; content: string }[];
}
export interface DevelopmentSupportData {
    sources: Source[];
    thoughtProcessData: ThoughtProcessData[];
    supportingContent: SupportingContentData;
}
//
export interface Response {
    conversationId: string;
    text: string;
    phiDetected: boolean;
    citations: Citation[];
    followupQuestions: string[];
    toolCalls?: ToolCallStatus[];
    // developmentSupportData is just for development and debugging purposes
    developmentSupportData?: DevelopmentSupportData;
}

export interface Answer {
    userMessage: string;
    response: Response | undefined;
}

export enum FeedbackType {
    Like = "like",
    Dislike = "dislike"
}
